import React, { useState, useEffect } from 'react';
import { loteService } from '../services/api';
import { toast } from 'react-toastify';
import './Dashboard.css';

/**
 * Componente Dashboard
 * Muestra estadísticas generales de los lotes
 */
const Dashboard = () => {
  const [estadisticas, setEstadisticas] = useState({
    total: 0,
    disponibles: 0,
    reservados: 0,
    vendidos: 0,
    valorTotal: 0,
    valorVendido: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    cargarEstadisticas();
  }, []);

  const cargarEstadisticas = async () => {
    try {
      setLoading(true);
      const stats = await loteService.obtenerEstadisticas();
      setEstadisticas(stats);
    } catch (error) {
      console.error('Error al cargar estadísticas:', error);
      toast.error('Error al cargar estadísticas: ' + (error.message || 'Error desconocido'));
    } finally {
      setLoading(false);
    }
  };

  const porcentajeVendido =
    estadisticas.total > 0 ? ((estadisticas.vendidos / estadisticas.total) * 100).toFixed(1) : 0;

  if (loading) {
    return <div className="dashboard-loading">Cargando estadísticas...</div>;
  }

  return (
    <div className="dashboard">
      <h2 className="dashboard-title">Dashboard</h2>
      <div className="dashboard-grid">
        <div className="dashboard-card">
          <div className="dashboard-card-icon">📊</div>
          <div className="dashboard-card-content">
            <h3>Total de Lotes</h3>
            <p className="dashboard-card-value">{estadisticas.total}</p>
          </div>
        </div>

        <div className="dashboard-card disponible">
          <div className="dashboard-card-icon">✅</div>
          <div className="dashboard-card-content">
            <h3>Disponibles</h3>
            <p className="dashboard-card-value">{estadisticas.disponibles}</p>
          </div>
        </div>

        <div className="dashboard-card reservado">
          <div className="dashboard-card-icon">⏳</div>
          <div className="dashboard-card-content">
            <h3>Reservados</h3>
            <p className="dashboard-card-value">{estadisticas.reservados}</p>
          </div>
        </div>

        <div className="dashboard-card vendido">
          <div className="dashboard-card-icon">💰</div>
          <div className="dashboard-card-content">
            <h3>Vendidos</h3>
            <p className="dashboard-card-value">{estadisticas.vendidos}</p>
          </div>
        </div>

        <div className="dashboard-card valor">
          <div className="dashboard-card-icon">💵</div>
          <div className="dashboard-card-content">
            <h3>Valor Total</h3>
            <p className="dashboard-card-value">
              $
              {estadisticas.valorTotal.toLocaleString('es-ES', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </p>
          </div>
        </div>

        <div className="dashboard-card valor-vendido">
          <div className="dashboard-card-icon">💸</div>
          <div className="dashboard-card-content">
            <h3>Valor Vendido</h3>
            <p className="dashboard-card-value">
              $
              {estadisticas.valorVendido.toLocaleString('es-ES', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </p>
          </div>
        </div>
      </div>

      <div className="dashboard-progress">
        <h3>Progreso de Ventas</h3>
        <div className="progress-bar">
          <div className="progress-fill" style={{ width: `${porcentajeVendido}%` }}>
            {porcentajeVendido}%
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
